/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import DashboardIcon from '@material-ui/icons/Dashboard';
import HistoryIcon from '@material-ui/icons/History';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import SendIcon from '@material-ui/icons/Send';
import SecurityIcon from '@material-ui/icons/Security';
import PaymentIcon from '@material-ui/icons/Payment';
import BusinessIcon from '@material-ui/icons/Business';
import PersonIcon from '@material-ui/icons/Person';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import SyncIcon from '@material-ui/icons/Sync';
import Search from '@material-ui/icons/Search';
import ReceiptIcon from '@material-ui/icons/Receipt';

export default [
  {
    subheader: 'Company management',
    neededActions: ['manageCompany', 'createCompany', 'listCompanies', 'manageBillingNote'],
    requires2FA: true,
    items: [
      {
        title: 'Add new company',
        href: '/super/create-company',
        icon: DashboardIcon,
        neededActions: ['manageCompany', 'createCompany']
      },
      {
        title: 'All Companies',
        href: '/super/companies',
        icon: HistoryIcon,
        neededActions: ['manageCompany', 'listCompanies']
      },
      {
        title: 'Billing Notes',
        href: '/super/billing-note',
        icon: ReceiptIcon,
        neededActions: ['manageBillingNote']
      }
    ]
  },
  {
    subheader: 'SuperAdmin management',
    neededActions: ['manageSuperAdmins', 'manageRestrictedSuperAdmins'],
    requires2FA: true,
    items: [
      {
        title: 'All SuperAdmins',
        href: '/super/superadmins',
        icon: AssignmentIndIcon,
        neededActions: ['manageSuperAdmins', 'manageRestrictedSuperAdmins']
      }
    ]
  },
  {
    subheader: 'App Notifications',
    neededActions: ['sendNotifications'],
    requires2FA: true,
    items: [
      {
        title: 'Send Push Notifications',
        href: '/super/notifications',
        icon: SendIcon,
        neededActions: ['sendNotifications']
      }
    ]
  },
  {
    subheader: 'IT Settings',
    neededActions: ['managePayments'],
    requires2FA: true,
    items: [
      {
        title: 'Payments',
        href: '/super/payments',
        icon: PaymentIcon,
        neededActions: ['managePayments']
      }
    ]
  },
  {
    subheader: 'Integrations',
    requires2FA: true,
    items: [
      {
        title: 'Integration Executions',
        href: '/super/integration-executions',
        icon: SyncIcon
      }
    ]
  },
  {
    subheader: 'Support',
    neededActions: ['supportSearch'],
    requires2FA: true,
    items: [
      {
        title: 'Search Payments',
        href: '/super/support/payments',
        icon: PaymentIcon
      },
      {
        title: 'Search Companies',
        href: '/super/support/companies',
        icon: BusinessIcon
      },
      {
        title: 'Search Employee',
        href: '/super/support/employees',
        icon: PersonIcon
      },
      {
        title: 'Search Commissions',
        href: '/super/support/sales-commissions',
        icon: PaymentIcon
      },
    ]
  },
  {
    subheader: 'Account Settings',
    requires2FA: false,
    items: [
      {
        title: '2FA Settings',
        href: '/super/account-settings/2fa',
        icon: SecurityIcon
      },
      {
        title: 'Manage Account',
        href: '/super/account-settings/manage-account',
        icon: AccountBoxIcon
      }
    ]
  },
  {
    subheader: '',
    requires2FA: false,
    items: [
      {
        title: 'Cerrar sesion',
        href: '/auth/logout',
        icon: ExitToAppIcon
      }
    ]
  }
];
